const state = () => ({
  user: null
});

const getters = {
  user: state => {
    return state.user;
  }
};

const actions = {
  async fetchUser({ commit }) {
    const { data } = await this.$http.get("auth/user");
    commit("setUser", data);
  }
};

const mutations = {
  setUser(state, data) {
    state.user = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
